__turbopack_context__.v({
  "container": "ReadMoreBlogsSection-module-scss-module__w3Nbgq__container",
  "slide": "ReadMoreBlogsSection-module-scss-module__w3Nbgq__slide",
});
